import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { Container, Row, Col, Table } from "react-bootstrap";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import { commonSelectProps, datetime, exportToExcel, formatNumberIndianWithDecimal, generatelargePdf, generatePdf } from "../utils/commonFunctions";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import KpiService from "../../Services/KpiService";import Select from 'react-select';

export default function MandallevelTargetsReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [distEnb, setDistEnb] = useState(false); const [Mandalenb, setMandalenb] = useState(false); const [distlist, setDistrictList] = useState(); const [mandallist, setMandalList] = useState(); const [ulblist, setulblist] = useState(); const [searchText, setSearch] = useState(""); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [Deptlist, setDeptlist] = useState([]); const [Mandalname, setMandalname] = useState(""); const [mandals, setMandals] = useState(); const [ulbs, setulbs] = useState();
  const [logindeptid, setlogindeptid] = useState("");const [yearList,setYearList] = useState([]);
  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid"); let deptId = localStorage.getItem("deptid");
  const [districts, setdistricts] = useState(); const [Distname, setDistname] = useState(); const [Deptname, setDeptname] = useState();
  let ulbcode = localStorage.getItem("ulbid"); let ulbname = localStorage.getItem("ulbname");
  const formik = useFormik({
    initialValues: { userId: "", district_id: "", mandal_id: "", ulb_id: "", department_id: "", periodic_id: "", year: "", date: "", Indicators: [{ indicator_id: "", entry_value: "" }], remarks: "" },
    onSubmit: (values) => { },
  });
  const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState("");
  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");
  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
  }, []);

  useEffect(() => {
MasterService.getfinyears().then((achievvalueres) => {
             if (achievvalueres.data) {
               let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
               setYearList(achievvalueres.data);
             }
           });


    MasterService.getDistricts().then((respo) => {
      if (respo.data) {
        setdistricts([ { id: "0", value: "All" }, ...(respo.data ?? []) ]);
        let options = respo.data.map((item, i) => {
          return (<option key={item.id} value={item.id}> {item.value} </option>);
        });
        setDistrictList([ { id: "0", value: "All" }, ...(respo.data ?? []) ]);
      }
    });
    if (["119", "117", "111", "113","112"].includes(roleid)) { formik.setFieldValue("district_id", district); }

    let params = { userId: username };
    MasterService.getApplicableMandalHods(params).then((res11) => {
      if (res11.data) {
        let options = res11.data?.SDESC.map((item, i) => {
          return (<option key={item.dept_id} value={item.dept_id}> {item.dept_name} </option>);
        });
        setDeptlist(res11.data?.SDESC);
      }
    });

    if (["111", "113", "114"].includes(roleid)) {
      setlogindeptid(deptId);
      formik.setFieldValue("department_id", deptId);
    }

    if (["111", "117", "113", "119"].includes(roleid)) {
      setDistname(localStorage.getItem("districtname"));
      MandalDropdown(deptId, district)

    }
    if (roleid === "113" || roleid === "119") {
      setDistEnb(true);
      setMandalenb(false);
      // ulbdeptlist.includes(deptId) ? formik.setFieldValue("ulb_id", "0"):
      // formik.setFieldValue("mandal_id", "0");
      // getEntrydata(deptId,"0");
    }

    if (roleid === "111"  || roleid === "117") {
      setDistEnb(true);
      setMandalenb(true);
      ulbdeptlist.includes(deptId) ? formik.setFieldValue("ulb_id", ulbcode) :
        formik.setFieldValue("mandal_id", mandal);
    }


    if (["111"].includes(roleid)) {


      ulbdeptlist.includes(deptId) ? setMandalname(ulbname) : setMandalname(localStorage.getItem("mandalname"));

      // const params = {
      //   userId: username,
      //   districtId: district,
      //   mandalId: ulbdeptlist.includes(deptId) ? "0" : mandal,
      //   ulbId: ulbdeptlist.includes(deptId) ? ulbcode : "0",
      //   deptId: deptId,
      // };
      // KpiService.getMandalTargetreport(params)
      //   .then((res) => {
      //     store.dispatch({ type: "HIDE_SPINNER" });
      //     if (res.data.SCODE === "02") {
      //       showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false);
      //     } else {
      //       if (res.data.SCODE === "01") {
      //         setselectedmandal(formik.values.mandal_id); setselecteddept(formik.values.department_id); setEntrydataEnb(true); setEntrydata(res.data.SDESC);
      //         if (!["116","119","117"].includes(roleid)) {
      //           setDeptname(localStorage.getItem("deptcodeName"));
      //         } else {
      //           let dept = res.data.SDESC[0].dept_name; setDeptname(dept);

      //         }
      //         let uniqueMandalss = [];
      //         if (ulbdeptlist.includes(deptId)) {
      //           uniqueMandalss = [...new Set(res.data.SDESC?.map((item) => item.ulb_name))];
      //         }
      //         else {
      //           uniqueMandalss = [...new Set(res.data.SDESC?.map((item) => item.mandal_name))];
      //         }
      //         setuniqueMandals(uniqueMandalss);
      //       } else {
      //         showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false);
      //       }
      //     }
      //   })
      //   .finally(() => {
      //     store.dispatch({ type: "HIDE_SPINNER" });
      //   });

      // getEntrydata(deptId,ulbdeptlist.includes(deptId)? ulbcode:mandal)
      ulbdeptlist.includes(deptId) ? formik.setFieldValue("ulb_id", ulbcode) : formik.setFieldValue("mandal_id", mandal);
    }
  }, []);


  const MandalDropdown = (departid, val) => {

    if (ulbdeptlist.includes(departid)) {
      console.log("departid", departid);
      let params1 = { userId: username, districtId: val };
      KpiService.getulbList(params1).then((response) => {
        if (response.data) {
          
         
          if(response.data?.SCODE === "01"){setulbs(response.data.SDESC);
          setulblist([ { ulb_code: "0", ulb_name: "All" }, ...(response.data?.SDESC ?? []) ]);}
          else{setulbs([ { ulb_code: "0", ulb_name: "All" } ]);setulblist([ { ulb_code: "0", ulb_name: "All" } ]);}
        }
        else{setulblist([])}
      });
    }
    else {
      let params = { district_id: val };
      MasterService.getMandals(params).then((res) => {
        setMandals(res.data);
        if (res.data) {
          let options = res.data.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
          setMandalList([ { id: "0", value: "All" }, ...(res.data?? []) ]);
        }
        else{setMandalList([])}
        
      });
    }
  };

  const getEntrydata = (yearrr) => {
    if (!formik.values.department_id || !yearrr) {
      return;
    }
    const params = {
      userId: username,
      districtId: ["119", "117", "113", "111"].includes(roleid) ? district : formik.values.district_id,
      mandalId: ulbdeptlist.includes(formik.values.department_id) ? "0" : formik.values.mandal_id,
      ulbId: (roleid === "117") ? "0" : ulbdeptlist.includes(formik.values.department_id) ? formik.values.ulb_id : "0",
      deptId: formik.values.department_id,
      year:yearrr
    };

    const filtermandal = ulbdeptlist.includes(formik.values.department_id) ? (ulbs?.find((item) => item.ulb_code === formik.values.ulb_id)) : mandals?.find((item) => item.id === formik.values.mandal_id);
    if (ulbdeptlist.includes(formik.values.department_id)?formik.values.ulb_id !== "0":formik.values.mandal_id !== "0") {
      ulbdeptlist.includes(formik.values.department_id) ? setMandalname(filtermandal?.ulb_name) : setMandalname(filtermandal?.value);
    }
    if (ulbdeptlist.includes(formik.values.department_id)?formik.values.ulb_id === "0":formik.values.mandal_id === "0") {
      setMandalname("ALL");
    }
    fetchEntryData(params);
    if (roleid === "114" || roleid === "116") {
      const filterdistrict = districts?.find((item) => item.id === formik.values.district_id);
      setDistname(filterdistrict?.value);
    } else {
      setDistname(localStorage.getItem("districtname"));
    }
  };
  const [uniqueMandals, setuniqueMandals] = useState(); const [selectedmandal, setselectedmandal] = useState(); const [selecteddept, setselecteddept] = useState();

  const fetchEntryData = (params) => {
    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.getMandalTargetreport(params)
      .then((res) => {
        store.dispatch({ type: "HIDE_SPINNER" });
        if (res.data.SCODE === "02") {
          showAlertMessage(res.data.SDESC, "warning");
          setEntrydata([]);
          setEntrydataEnb(false);
        } else {
          if (res.data.SCODE === "01") {
            setselectedmandal(formik.values.mandal_id); setselecteddept(formik.values.department_id); setEntrydataEnb(true); setEntrydata(res.data.SDESC);
            if (!["116","119","117"].includes(roleid) ) {
               setDeptname(localStorage.getItem("deptcodeName"));
            } else {
              let dept = res.data.SDESC[0].dept_name;
              setDeptname(dept);
             
            }
            let uniqueMandalss = [];
            if (ulbdeptlist.includes(logindeptid)) {
              uniqueMandalss = [...new Set(res.data.SDESC?.map((item) => item.ulb_name))];


            }
            else {
              uniqueMandalss = [...new Set(res.data.SDESC?.map((item) => item.mandal_name))];
            }
            setuniqueMandals(uniqueMandalss);
          } else {
            showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false);
          }
        }
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  const Emptyfields = () => {
    setEntrydataEnb(false);
    formik.setFieldValue("mandal_id", "");
    formik.setFieldValue("ulb_id", "");
  };
  const filteredData =
    searchText.length > 0 && EntryData?.length
      ? EntryData.filter((item) => {
        return (
          item &&
          Object.keys(item).some((key) => {
            const value = item[key];
            return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase());
          })
        );
      })
      : EntryData;
  const filteredMandals = uniqueMandals?.filter((mandal) => filteredData?.some((item) => ulbdeptlist.includes(roleid === "117" ? formik.values.department_id : logindeptid) ? item.ulb_name === mandal : item.mandal_name === mandal));

  const Oncngfun = () => {
    if (roleid !== "119" && roleid !== "117") {
      formik.setFieldValue("district_id", "");
    }
    if (roleid !== "117") { formik.setFieldValue("mandal_id", ""); formik.setFieldValue("ulb_id", ""); }
  };

  const hodenb = (val) => {
    setEntrydataEnb(false); if (val) {
      setlogindeptid(val); Oncngfun();
      if (roleid === "119") {
        MandalDropdown(val, district)
      }
      if (roleid === "117") {

        // getEntrydata(val,"0")
        // const params = { userId: username, districtId: ["119", "117", "113", "111"].includes(roleid) ? district : formik.values.district_id, mandalId: ulbdeptlist.includes(val) ? "0" : mandal, ulbId: "0", deptId: val, };


        if (ulbdeptlist.includes(val)) {
          formik.setFieldValue("ulb_id", "0");
          setMandalname("All")
        } else {
          setMandalname(localStorage.getItem("mandalname"));
        }

        // KpiService.getMandalTargetreport(params).then((res) => {
        //   store.dispatch({ type: "HIDE_SPINNER" });
        //   if (res.data.SCODE === "02") { showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); }
        //   else {
        //     if (res.data.SCODE === "01") {
        //       setselectedmandal(ulbdeptlist.includes(val) ? formik.values.mandal_id : formik.values.ulb_id); setselecteddept(formik.values.department_id); setEntrydataEnb(true); setEntrydata(res.data.SDESC);
        //       if (!["116","119","117"].includes(roleid)) { setDeptname(localStorage.getItem("deptcodeName")); }
        //       else {  let dept = res.data.SDESC[0].dept_name; setDeptname(dept);}
        //       let uniqueMandalss = []; if (ulbdeptlist.includes(val)) { uniqueMandalss = [...new Set(res.data.SDESC?.map((item) => item.ulb_name))]; } else { uniqueMandalss = [...new Set(res.data.SDESC?.map((item) => item.mandal_name))]; } setuniqueMandals(uniqueMandalss);

        //     }
        //     else { showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); }
        //   }
        // }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
      }


    }
  }
  return (
    <>
      <Menubar />
      <Container fluid className="map-header1">
        <div className="sa-title">
          <h2>
            {ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"} Targets <span> Report</span>
          </h2>
        </div>
      </Container>

      <Container fluid style={{ width: "87%" }} className="outer-page-content-container mt-3">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label htmlFor="department_id" className="mb-1 fw-bold">
                    {" "}
                    HOD Name
                  </label>
                  <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, 
                    isDisabled: !["116","119","117"].includes(roleid), extraOnChange: (option) => { hodenb(option ? option.dept_id : "");
                      formik.setFieldValue("year", "");setEntrydata([]);
                     } })} />
                </Col>

                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label htmlFor="district_id" className="mb-1 fw-bold">
                    {" "}
                    District{" "}
                  </label>{" "}
                  <span style={{ color: "red" }}> *</span>
                    <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: distEnb, 
                    extraOnChange: (option) => {  MandalDropdown(formik.values.department_id, option? option.id:"");Emptyfields();
                      formik.setFieldValue("year", "");setEntrydata([]);
                     } })} />
                  
                </Col>
                {ulbdeptlist.includes(logindeptid) ?
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                    <label htmlFor="mandal_id" className="mb-1 fw-bold">
                      {" "}
                      ULB{" "}
                    </label>
                    <span style={{ color: "red" }}> *</span>
                    <Select {...commonSelectProps({ name: "ulb_id", options: ulblist, value: formik.values.ulb_id, optionValueKey: "ulb_code", optionLabelKey:"ulb_name", formik, isDisabled: Mandalenb,
                       extraOnChange: (option) => {
                        formik.setFieldValue("year", "");setEntrydata([]);
                          // getEntrydata(formik.values.department_id,option? option.ulb_code:"");
                          } })} />
                   
                  </Col> :

                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                    <label htmlFor="mandal_id" className="mb-1 fw-bold">
                      {" "}
                      Mandal{" "}
                    </label>
                    <span style={{ color: "red" }}> *</span>
                      <Select {...commonSelectProps({ name: "mandal_id", options: mandallist, value: formik.values.mandal_id, optionValueKey: "id", optionLabelKey:"value", formik, isDisabled: Mandalenb, extraOnChange: (option) => { formik.setFieldValue("year", "");setEntrydata([]); } })} /> </Col>}

                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}> <label className="mb-1 fw-bold">Year </label> <span style={{ color: "red" }}> *</span> <Select {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { getEntrydata(option? option.id:""); } })} /> </Col>
              </Row>
            </div>
            <br />

            {entrydataEnb && (
              <>
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                    <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} id="search-container" >
                      <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
                      <input type="text" placeholder="Search" value={searchText} onChange={(event) => setSearch(event.target.value)} onFocus={(e) => { const container = e.currentTarget.parentElement; container.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; container.style.border = "1px solid #353935"; container.style.width = "100%"; }} onBlur={(e) => { const container = e.currentTarget.parentElement; container.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; container.style.border = "1px solid #ddd"; }} style={{ flex: 1, border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
                    </div>
                  </Col>

                  <Col className=" mb-2 ">
                    <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => formik.values.mandal_id !== "0" ? generatePdf("#my-table", `${ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"}LevelTargetReport`, formik.values.department_id !== "0" ? 4 : 5) : generatelargePdf("#my-table", `${ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"}LevelTargetReport`)} style={{ float: "right", marginLeft: "3px" }}>
                      PDF <MdOutlinePictureAsPdf />
                    </button>
                    <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", `${ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"}LevelTargetReport`)}>
                      Excel
                      <AiFillFileExcel style={{ fontSize: "18px" }} />
                    </button>
                  </Col>
                </Row>

                <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1">
                  <span className="style-1">{ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"} Level Targets Report Of Year {formik.values.year}</span>
                  <br />


                  <span className="style-1"> HOD Name:</span> <span className="style-2">{formik.values.department_id === "0" ? "ALL" : Deptname}</span>

                  <span className="style-1">District:</span> <span className="style-2">{Distname}</span>
                  {selectedmandal !== "0" && (
                    <>
                      <span className="style-1">{ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"}:</span> <span className="style-2">{Mandalname}</span>
                    </>
                  )}
                  <div className="text-end style-1">
                    Report On : {currentdate} {currenttime}
                  </div>
                </div>
                <div id="table-scroll" className="table-scroll">
                  <div className="table-wrap">
                    <Table striped className="custom-table sticky-table" id="my-table">
                      <thead>
                        {entrydataEnb && (
                          <>
                            <tr className="text-center only-export">
                              <th colSpan={selecteddept !== "0" ? filteredMandals.length + 3 : filteredMandals.length + 4} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                                <span className="style-1">{ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"} Level Targets Report Of Year {formik.values.year}</span>
                              </th>
                            </tr>

                            <tr className="text-center only-export">
                              <th colSpan={selecteddept !== "0" ? filteredMandals.length + 3 : filteredMandals.length + 4} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>

                                <span style={{ color: "black" }}> HOD Name:</span> &nbsp; <span style={{ color: "#FBB040" }}>{formik.values.department_id === "0" ? "ALL" : Deptname}</span>
                                <span style={{ color: "black" }}>,&nbsp;District:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Distname}</span>
                                {selectedmandal !== "0" && (<> <span style={{ color: "black" }}>,&nbsp;{ulbdeptlist.includes(logindeptid) ? "ULB" : "Mandal"}:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Mandalname}</span> </>)}
                              </th>
                            </tr>
                            <tr className="only-export">
                              <th colSpan={selecteddept !== "0" ? filteredMandals.length + 3 : filteredMandals.length + 4}>
                                <div className="text-end style-1">
                                  Report On : {currentdate} {currenttime}
                                </div>
                              </th>
                            </tr>
                          </>
                        )}
                        <tr className="text-center">
                          <th className="sticky-col sticky-sno">Sl.No.</th>{formik.values.department_id === "0" && <th >HOD Name</th>}
                          <th rowSpan={1} className="sticky-col sticky-INDICATOR indicator-cell"> Indicator </th>
                          <th className="sticky-col sticky-UNIT">Unit</th>
                          {filteredMandals.map((mandal, idx) => (<th key={idx} colSpan={1}> {mandal} </th>))}
                        </tr>
                      </thead>

                      <tbody>
                        {[...new Set(filteredData.map((item) => item.indicator_id))].map((indicatorId, i) => {
                          const indicatorRows = filteredData.filter((item) => item.indicator_id === indicatorId);
                          const indicatorName = indicatorRows[0]?.indicator_name;
                          const unitName = indicatorRows[0]?.unit_name;
                          const unitCatid = indicatorRows[0]?.unit_cat_id;
                          return (
                            <tr key={indicatorId}>
                              <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}> {i + 1} </td>
                              {formik.values.department_id === "0" && <td > {indicatorRows[0]?.dept_name} </td>}
                              <td className="sticky-col sticky-INDICATOR indicator-column">{indicatorName}</td> <td style={{ textAlign: "left" }} className="sticky-col sticky-UNIT"> {unitName} </td>
                              {filteredMandals.map((mandalName, idx) => {
                                console.log("mandalName", mandalName);
                                const match = indicatorRows.find((item) => ulbdeptlist.includes(logindeptid) ? item.ulb_name === mandalName : item.mandal_name === mandalName);
                                const value = unitCatid === 1 ? formatNumberIndianWithDecimal(match?.targets_2025) : match?.targets_2025;
                                return (<td key={idx} style={{ textAlign: "right" }}> {value !== null && value !== undefined ? value : ""} </td>);
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </>
            )}
          </Form>
        </FormikProvider>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}

